import { PublicErrorMessage } from "../../apis";

 
const CustomErrorToast = (message?: string) => {
  return (
    <div
      className="error-toast"
      dangerouslySetInnerHTML={{ __html: message || PublicErrorMessage }}
    />
  );
};

const CustomToast = (message?: string) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: message || PublicErrorMessage }} />
  );
};

export { CustomErrorToast, CustomToast };
